import { IAggregator, ISyncEndpoint } from '../../types/aggregator.types';

export type { ISyncEndpoint };

/**
 * Every endpoint matching `endpointName`, one entry per addon instance. A brand can connect the
 * same integration more than once (one instance per site), so this returns a list rather than a
 * winner — the heading turns it into a dropdown when there is more than one.
 */
export const getSyncEndpoints = (
  externalSystems: IAggregator[] = [],
  endpointName = 'recipe management',
): ISyncEndpoint[] =>
  externalSystems.flatMap((externalSystem) =>
    externalSystem.configuredAddons.flatMap((addon) =>
      addon.endpoints
        .filter((endpoint) => endpoint.endpointName.toLowerCase() === endpointName.toLowerCase())
        .map((endpoint) => ({
          ...endpoint,
          name: externalSystem.name,
          externalSystemId: externalSystem.aggregatorId,
          instanceId: addon.instanceId,
          instanceName: addon.instanceName,
        })),
    ),
  );

/**
 * The first matching endpoint. Callers that only ask "is this sync available at all?" are served
 * fine by this; anything that acts on a specific instance should use `getSyncEndpoints`.
 */
export const getSyncEndpoint = (
  externalSystems: IAggregator[] = [],
  endpointName = 'recipe management',
): ISyncEndpoint | null => getSyncEndpoints(externalSystems, endpointName)[0] ?? null;
